export default __webpack_public_path__ + "static/media/arrow_drop_down.328360ea.svg";